// 提单编辑公用页面
<template>
    <div class="main-center" style=": 80px;">
        <!--个人信息-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order1.svg" alt="">
                <span>{{$t("userCenter.personalInfo.personalInfo")}}</span>
            </div>
            <div class="cardBody">
                <!--个人信息-->
                <div class="flex flex-space-around  margin-bottom">
                    <!--客户代码-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="blackColor">
                                {{$t("userCenter.personalInfo.companyCode")}}
                            </span>
                        </div>
                        <el-input v-model="customer.companyCode"  type="textarea" autosize
                                  clearable readonly/>
                    </div>
                    <!--客户名称(CN)-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="blackColor">
                                {{$t("userCenter.personalInfo.companyNameCn")}}
                            </span>
                        </div>
                        <el-input v-model="customer.companyNameCn"  type="textarea" autosize
                                  clearable readonly/>
                    </div>
                    <!--客户名称(EN)-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="blackColor">
                                {{$t("userCenter.personalInfo.companyName")}}
                            </span>
                        </div>
                        <el-input v-model="customer.companyName"  type="textarea" autosize
                                  clearable readonly/>
                    </div>

                </div>
            </div>
        </div>
        <!--底部按钮组-->
        <div class="footer-group">
            <!--修改信息-->
            <el-button class="save-yellow-button" type="warning" :disabled=true>
                {{$t("userCenter.personalInfo.modifyInformation")}}
            </el-button>
            <!--修改密码-->
            <el-button class="save-blue-button"
                       @click="cgpwdVisible = true ">
                {{$t("userCenter.personalInfo.changePassword")}}
            </el-button>

        </div>
        <!-- 修改密码界面 -->
        <el-dialog :title="this.$t('userCenter.personalInfo.resetPassword')"
                   width="30%" :visible.sync="cgpwdVisible" :close-on-click-modal="false"
                   :modal-append-to-body='false'  @opened="handleDialogOpened" @close="handleCloseDialog" center>
            <el-form :model="pswForm" status-icon :rules="rules" ref="pswForm">
                <el-form-item label="" prop="currentPassWord" class="form-item-first">
                    <el-input v-model="pswForm.currentPassWord" class="login-input"
                              show-password
                              v-if="pwdSwitch"
                              :placeholder="$t('userCenter.personalInfo.currentPassWord')"
                              @input="formatUpper('pswForm','currentPassWord',pswForm.currentPassWord)">
                        <i slot="prefix" class="el-icon-lock icon"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="passWord">
                    <el-input v-model="pswForm.passWord" class="login-input"
                              show-password
                              v-if="pwdSwitch"
                              :placeholder="$t('userCenter.personalInfo.newPassword')"
                              @input="formatUpper('pswForm','passWord',pswForm.passWord)">
                        <i slot="prefix" class="el-icon-lock icon"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="checkPass">
                    <el-input v-model="pswForm.checkPass" class="login-input"
                              show-password
                              v-if="pwdSwitch"
                              :placeholder="$t('userCenter.personalInfo.confirmPassword')"
                              @input="formatUpper('pswForm','checkPass',pswForm.checkPass)">
                        <i slot="prefix" class="el-icon-lock icon"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 5px;">
                <el-button type="primary" plain
                           @click="handleCloseDialog()">
                    {{$t("common.cancelButton")}}
                </el-button>
                <el-button type="primary" @click="changePassword()">
                    {{$t("common.confirmButton")}}
                </el-button>
            </div>
        </el-dialog>
        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'personalInfo',
    computed: {
        /************************************ 页面按钮国际化信息 ***********************************/
        //保存草稿按钮
        saveButton() {
            return this.$t("common.saveButton");
        },

    },
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t("userCenter.personalInfo.newPasswordTip"));
            } else {
                if (this.pswForm.checkPass !== '') {
                    this.$refs.pswForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t("userCenter.personalInfo.confirmPasswordTip"));
            } else if (value !== this.pswForm.passWord) {
                callback(this.$t("userCenter.personalInfo.confirmPasswordWarn"));
            } else {
                callback();
            }
        };
        var validatePass3 = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t("userCenter.personalInfo.currentPassWordTip"));
            } else {
                if (this.pswForm.checkPass !== '') {
                    this.$refs.pswForm.validateField('checkPass');
                }
                callback();
            }
        };

        return {
            pwdSwitch : false,
            cgpwdVisible: false,
            customer: {
                companyCode: "",
                companyNameCn: "",
                companyName: "",
            },
            pswForm: {
                currentPassWord: '',
                passWord: '',
                checkPass: '',

            },
            rules: {
                currentPassWord: [
                    {validator: validatePass3, trigger: 'blur'}
                ],
                passWord: [
                    {validator: validatePass, trigger: 'blur'}
                ],
                checkPass: [
                    {validator: validatePass2, trigger: 'blur'}
                ],
            },
        }
    },
    methods: {
        // 页面数据初始化
        initPageInfo() {
            console.log(this.$route);
            if (this.$route.query == null) {
                return;
            }
            if (this.$route.query.custContactsDTO == null) {
                return;
            }
            let custContactsDTO = this.$route.query.custContactsDTO;
            this.setFieldValue(custContactsDTO);
            let custC= JSON.parse (sessionStorage.getItem("CUSTOMER"));
            this.setFieldValue(custC);
        },
        //页面初始化赋值
        setFieldValue(custContactsDTO){
            this.customer.companyCode = custContactsDTO.companyCode;
            this.customer.companyNameCn = custContactsDTO.companyNameCn;
            this.customer.companyName = custContactsDTO.companyName;
        },

        handleDialogOpened(){
            this.pwdSwitch = true;
        },
        //关闭时候清空表单
        handleCloseDialog() {
            this.pswForm.currentPassWord = "";
            this.pswForm.passWord = "";
            this.pswForm.checkPass = "";
            this.cgpwdVisible=false;
            this.pwdSwitch = false;
        },
        //确认修改
        changePassword() {
            // this.$refs[this.pswForm].validate((valid) => {
            //     if (valid) {
            //         alert('submit!');
            //     } else {
            //         console.log('error submit!!');
            //         return false;
            //     }
            // });

            const params = new URLSearchParams();
            params.append("currentPassWord", this.pswForm.currentPassWord);
            params.append("passWord", this.pswForm.passWord);

            this.axios.post("/api/user/changePassword/", params, {
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.handleCloseDialog();
                    this.logout();
                    this.showMessage(false, this.responseCode, "success");
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        //修改成功后退出登录
        logout() {
            if (!sessionStorage.getItem("ACCOUNT_CODE")
                || sessionStorage.getItem("ACCOUNT_CODE") === "") {
                this.showMessage(false, this.$t("message.logoutMsg"), "warning");
            } else {
                //调用后端退出登录API
                this.axios({
                    method: 'post',
                    url: '/api/user/logout',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        // 清空session中的账号ji信息,并跳转到首页登录
                        sessionStorage.setItem("ACCOUNT_CODE", "");
                        sessionStorage.setItem("COMPANY_CODE", "");
                        this.userName = this.$t("header.nonLogin");
                        this.companyName = "";
                        this.$router.push('/homePage');
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            }
        },

    },
    created() {
        // this.initCombos();
        this.initPageInfo();
        this.$parent.updateHeaderAside();
    },
    mounted() {
    }
}
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
@import "../../assets/scss/public.scss";

.main-center {
    width: 1248px;
    height: 501px;
    margin: 0 auto;
}

.inputName {
    flex: 1;
    margin: 9px 15px;
}

.inputName ::v-deep.el-input.is-disabled .el-input__inner {
    background-color: #FFFFFF;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}

//重写el-input样式，只显示下边框
.inputName ::v-deep.el-input__inner {
    border-radius: 0; // 去掉圆角
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    border-bottom-width: 1px; //只显示下边框
}

.condtion-box{ .el-select{pointer-event:none} }

.cardBox {
    background: $colorA;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 16px 16px 16px 16px;
    width: 1000px;
    margin: 0 auto;
    position: relative;
    padding-top: 30px;
    margin-top: 96px;

}

// 底部按钮组
.footer-group {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 15px;

    .save-yellow-button, .save-blue-button, .save-green-button, .return-button {
        height: 45px;
        line-height: 45px;
        padding: 0px 15px;
        font-size: 17px;
        color: $colorA;
        border: 1px solid #F6F6F6;
    }

    .save-blue-button {
        background: $colorJ;
    }
}

.footerSpan {
    width: 100%;
    height: 120px;
    visibility: hidden;
    margin-bottom: 0px;
}

</style>